import * as React from 'react'

import getConfig from 'next/config'

import { RouteConfigs } from '@grandvisionhq/frk-routing'
import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/frames'
import { PromoteInstallmentsGraphContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import {
  commonSpecifications,
  getDeliveryIndicatorConfig,
  graphPromoteInstallmentsConfiguration,
} from '../../../configuration'

const { publicRuntimeConfig } = getConfig()
const defaultAppointmentTypeId = publicRuntimeConfig.opco?.defaultAppointmentTypeIdPDP

const slots: Props['slots'] = {
  AfterPrice: () => (
    <PromoteInstallmentsGraphContainer opcoConfiguration={graphPromoteInstallmentsConfiguration} />
  ),
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const pdpRoute: RouteConfigs | undefined = defaultAppointmentTypeId
    ? {
        route: 'appointments.book',
        query: new URLSearchParams({ typeId: defaultAppointmentTypeId }),
      }
    : undefined

  return (
    <Page
      {...props}
      slots={slots}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={commonSpecifications}
      bookAppointmentRouteConfig={pdpRoute}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
